import { useParams, useHistory } from 'react-router-dom';
import { getAppRoutes } from 'Pages/App/App.constants';
import { useRoleDetail, useUpdateRole } from '../Roles.hooks';
import PermissionList, { RoleSubmitPayload } from './PermissionList';
import Spin from 'Components/Spin/Spin';

function EditRole() {
	const { roleId } = useParams<{ roleId: string }>();
	const history = useHistory();
	const { role, permissionList, loading } = useRoleDetail(roleId);
	const [updateRole, { loading: updating }] = useUpdateRole();

	const handleSubmit = async (values: RoleSubmitPayload) => {
		await updateRole(roleId, values);
		history.push(getAppRoutes().ROLES);
	};

	if (loading || !role) return <Spin />

	return (
		<PermissionList
			mode="edit"
			permissionList={permissionList}
			initialValues={{ roleName: role.role, description: role.description }}
			loading={updating}
			onCancel={() => history.goBack()}
			onSubmit={handleSubmit}
		/>
	);
}

export default EditRole;